import { useEffect, useState } from "react";
import { subscribeLoading } from "@/lib/api";

/**
 * Thin top-of-page progress bar that animates while any axios call is in flight.
 * No external deps — pure CSS transitions. Sits above all content.
 */
export default function TopLoader() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let t;
    return subscribeLoading((n) => {
      if (n > 0) {
        clearTimeout(t);
        setActive(true);
      } else {
        // small delay so quick requests still flash
        t = setTimeout(() => setActive(false), 250);
      }
    });
  }, []);

  return (
    <div
      data-testid="top-loader"
      aria-hidden={!active}
      className={`fixed top-0 left-0 right-0 z-[100] h-[3px] pointer-events-none transition-opacity duration-200 ${active ? "opacity-100" : "opacity-0"}`}
    >
      <div
        className="h-full origin-left animate-[topbar_1.4s_ease-in-out_infinite]"
        style={{
          background: "linear-gradient(90deg, transparent, var(--theme-primary, #D95D39), transparent)",
          backgroundSize: "200% 100%",
        }}
      />
      <style>{`
        @keyframes topbar {
          0% { background-position: 100% 0; }
          100% { background-position: -100% 0; }
        }
      `}</style>
    </div>
  );
}
